import { call, put, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
    API_CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP,
    API_DOWNLOAD_REPORT,
    API_FETCH_BASIC_DATA,
    API_FETCH_PAYMENT_GATEWAY_CREDENTIAL,
    API_FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA,
    API_GENERATE_REPORT,
    API_GET_ACTIVE_REPORTS,
    API_UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP,
} from 'utils/API/apiUrls';

import * as paymentGatewayCredentialActions from './paymentGatewayCredentials.actions';
import { POST } from 'utils/fetchWrappers';

import {
    CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST,
    DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
    FETCH_FORM_DATA_PRICING_SECTION_REQUEST,
    FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_REQUEST,
    FETCH_PAYMENT_GATEWAY_CREDENTIALS_REQUEST,
    GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
    GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
    UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST,
} from './paymentGatewayCredentials.constants';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { toast } from 'react-toastify';
import { REPORT_TYPE_ENUM } from 'utils/constants/commonValues';
import { SECTION_TYPE_TO_URL_MAP } from '../constants';
import * as loaderActions from 'redux/common/loader/loader.actions';
// import { hideLoader } from 'redux/common/loader/loader.actions';

const getRequestData = (payload, isListFetchData) => {
    let request = {};
    if (isListFetchData) {
        request = {
            pageNo: payload.pageIndex || 1,
            pageLimit: payload.pageSize || 10,
        };
    }
    if (payload.createdOn) {
        request.startDateTime = moment(payload.createdOn.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        request.endDateTime = moment(payload.createdOn.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
    }
    if (payload.pgName) {
        request.pgName = [payload.pgName];
    }
    if (payload.paymentMode) {
        request.paymentMode = [payload.paymentMode];
    }
    if (payload.category) {
        request.category = [payload.category];
    }
    if (payload.mcc) {
        request.mcc = [payload.mcc];
    }
    if (payload.credentialId) {
        request.credentialId = payload.credentialId;
    }
    if (payload.reportFileName) {
        request.reportFileName = payload.reportFileName;
    }
    if (payload.reportType) {
        request.reportType = payload.reportType;
    }
    return request;
};

export function* fetchPaymentGatewayCredentials(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;

        const request = getRequestData(payload, true);

        const { data } = yield call(
            POST,
            API_FETCH_PAYMENT_GATEWAY_CREDENTIAL,
            request
        );

        if (data) {
            yield put(
                paymentGatewayCredentialActions.fetchPayementGatewayCredentialsSuccess(
                    data
                )
            );
        } else if (data && data.errorMessage) {
            yield put(
                paymentGatewayCredentialActions.fetchPayementGatewayCredentialsFailure(
                    {
                        error: data,
                    }
                )
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            paymentGatewayCredentialActions.fetchPayementGatewayCredentialsFailure(
                { error: data }
            )
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* generatePaymentGatewayCredentialReport(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        let request = {};
        request = getRequestData(payload);
        const { data } = yield call(POST, API_GENERATE_REPORT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                paymentGatewayCredentialActions.generatePaymentGatewayCredentialReportSuccess(
                    data
                )
            );
        } else if (data && data.errorMessage) {
            const errorMessage = data.errorMessage || '';
            yield put(
                paymentGatewayCredentialActions.generatePaymentGatewayCredentialReportError(
                    {
                        error: errorMessage || '',
                    }
                )
            );
            if (errorMessage) {
                toast.error(errorMessage);
            }
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data.errorMessage || '';
        yield put(
            paymentGatewayCredentialActions.generatePaymentGatewayCredentialReportError(
                {
                    error: errorMessage || '',
                }
            )
        );
        if (errorMessage) {
            toast.error(errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* getActivePaymentGatewayCredentialReportDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { data } = yield call(POST, API_GET_ACTIVE_REPORTS, {
            reportType: REPORT_TYPE_ENUM.PG_MID_REPORT,
        });
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                paymentGatewayCredentialActions.getActivePaymentGatewayCredentialReportSuccess(
                    data
                )
            );
        } else if (data && data.errorMessage) {
            yield put(
                paymentGatewayCredentialActions.getActivePaymentGatewayCredentialReportError(
                    {
                        error: data,
                    }
                )
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            paymentGatewayCredentialActions.getActivePaymentGatewayCredentialReportError(
                {
                    error: data,
                }
            )
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* downloadPaymentGatewayCredentialReportRequest(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            requestId: payload.requestId,
            reportType: REPORT_TYPE_ENUM.PG_MID_REPORT,
        };
        const { data } = yield call(POST, API_DOWNLOAD_REPORT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                paymentGatewayCredentialActions.downloadPaymentGatewayCredentialReportSuccess(
                    data.fileUrl
                )
            );
            if (data.fileUrl) {
                const link = document.createElement('a');
                link.href = data.fileUrl;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else if (data && data.errorMessage) {
            yield put(
                paymentGatewayCredentialActions.downloadPaymentGatewayCredentialReportError(
                    {
                        error: data.errorMessage,
                    }
                )
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            paymentGatewayCredentialActions.downloadPaymentGatewayCredentialReportError(
                {
                    error: data,
                }
            )
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* createPaymentGatewayCredentialStep(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType, formSectionData } = actions;
        console.log(formSectionData, payload, "payloadpayload");

        // console.log("createPaymentGatewayCredentialStep", payload, sectionType, formSectionData);
        const resp = yield call(
            POST,
            API_CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP(
                SECTION_TYPE_TO_URL_MAP[sectionType]
            ),
            payload
        );
        const {data} =resp;
        // console.log("API_CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP data", resp);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                paymentGatewayCredentialActions.createPaymentGatewayCredentialStepSuccess(
                    data,
                    sectionType,
                    payload,
                    formSectionData
                )
            );
        } else if (data && data.errorMessage) {
            const errorMessage = data.errorMessage ;
            yield put(
                paymentGatewayCredentialActions.createPaymentGatewayCredentialStepError(
                    {
                        error: data.errorMessage || '',
                    },
                    sectionType
                )
            );
            if (errorMessage) {
                toast.error(errorMessage);
            }
        }
    } catch (response) {
        const errorMessage = response.message || '';
        yield put(
            paymentGatewayCredentialActions.createPaymentGatewayCredentialStepError(
                {
                    error: errorMessage || '',
                },
                actions.sectionType
            )
        );
        if (errorMessage) {
            toast.error(errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchPaymentGatewayCredentialData(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(
            POST,
            API_FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA,
            payload
        );
        // TODO: add apiStatus check as well
        if (data) {
            yield put(
                paymentGatewayCredentialActions.fetchPaymentGatewayCredentialDataSuccess(
                    data
                )
            );
        } else if (data && data.errorMessage) {
            yield put(
                paymentGatewayCredentialActions.fetchPaymentGatewayCredentialDataError(
                    {
                        error: data,
                    }
                )
            );
        }
    } catch (response) {
        const { data } = response;
        yield put(
            paymentGatewayCredentialActions.fetchPaymentGatewayCredentialDataError(
                { error: data }
            )
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* updatePaymentGatewayCredentialStep(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType, formSectionData } = actions;
        // console.log("123");
        // console.log("payload", payload);
        // console.log("formSectionData", formSectionData);
        let actionType = '';
        if (formSectionData?.actionType) {
            actionType = formSectionData.actionType;
            delete formSectionData.actionType;
        }

        const  resp = yield call(
            POST,
            //API_CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP(
            API_UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP(
                SECTION_TYPE_TO_URL_MAP[sectionType]
            ),
            payload
        );
        const {data} = resp;
        // console.log("data",resp);

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            if (actionType === 'create') {
                yield put(
                    paymentGatewayCredentialActions.createPaymentGatewayCredentialStepSuccess(
                        data,
                        sectionType,
                        payload,
                        formSectionData
                    )
                );
            } else {
                yield put(
                    paymentGatewayCredentialActions.updatePaymentGatewayCredentialStepSuccess(
                        data,
                        sectionType,
                        formSectionData
                    )
                );
            }

        } else if (data && data.errorMessage) {
            const errorMessage = data.errorMessage ;
            yield put(
                paymentGatewayCredentialActions.updatePaymentGatewayCredentialStepError(
                    {
                        error: data.errorMessage || '',
                    }
                )
            );
            if (errorMessage) {
                toast.error(errorMessage);
            }

        }
    }

     catch (response) {

        const errorMessage = response.message || '';
        yield put(
            paymentGatewayCredentialActions.updatePaymentGatewayCredentialStepError(
                {
                    error: errorMessage || '',
                }
            )
        );
        if (errorMessage) {
            toast.error(errorMessage);
        }

    }
    yield put(loaderActions.hideLoader());
}

function* fetchFormDataPricingSectionRequest(payload) {
    yield put(loaderActions.showLoader());
    try {
        const  resp = yield call(
            POST,
            API_FETCH_BASIC_DATA,
            payload
        );
        const {data} = resp;
        console.log("data",resp);

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {

            yield put(
                paymentGatewayCredentialActions.fetchFormDataPricingSectionSuccess(
                    data
                )
            );
        } else if (data && data.errorMessage) {
            const errorMessage = data.errorMessage ;
            yield put(
                paymentGatewayCredentialActions.fetchFormDataPricingSectionFailed(
                    {
                        error: data.errorMessage || '',
                    }
                )
            );
            if (errorMessage) {
                toast.error(errorMessage);
            }

        }
    } catch(e) {
        const errorMessage = e.message || '';
        yield put(
            paymentGatewayCredentialActions.updatePaymentGatewayCredentialStepError(
                {
                    error: errorMessage || '',
                }
            )
        );
        if (errorMessage) {
            toast.error(errorMessage);
        }
    }

    yield put(loaderActions.hideLoader());
}

export function* paymentGatewayCredentialsSaga() {
    yield takeLatest(
        FETCH_PAYMENT_GATEWAY_CREDENTIALS_REQUEST,
        fetchPaymentGatewayCredentials
    );
    yield takeLatest(
        GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
        generatePaymentGatewayCredentialReport
    );
    yield takeLatest(
        GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
        getActivePaymentGatewayCredentialReportDetails
    );
    yield takeLatest(
        DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
        downloadPaymentGatewayCredentialReportRequest
    );
    yield takeLatest(
        CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST,
        createPaymentGatewayCredentialStep
    );
    yield takeLatest(
        FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_REQUEST,
        fetchPaymentGatewayCredentialData
    );
    yield takeLatest(
        UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST,
        updatePaymentGatewayCredentialStep
    );
    yield takeLatest(
        FETCH_FORM_DATA_PRICING_SECTION_REQUEST,
        fetchFormDataPricingSectionRequest
    );
}
